import {changeNestedValue} from "@Common/utils/arr-path";

import {basicDownloadDeliveryModules} from "./basic-download-delivery-modules";
import {basicItemModules}             from "./basic-item-modules";
import {basicPickupAddressModules}    from "./basic-pickup-address-modules";
import {DeliveryMethodLogic}          from "./delivery-method-logic";
import {
    cleanItem,
    itemEditor,
}                                     from "./expo-types/expo-types";
import {MailingModules}               from "./mailing-modules";
import {PdfDownloadLogic}             from "./pdf-download-logic";
import {QuantityLogic}                from "./quantity-logic";

export const itemModules = (
    {
        templateOptions, item,
        getDefaultQuantity=undefined,
        getDefaultMailClass=undefined,
    }
) => [
    ...basicItemModules({
        item, templateOptions,
    }),
    ...basicDownloadDeliveryModules({
        item, templateOptions,
    }),
    ...basicPickupAddressModules({}),

    ...MailingModules({item, templateOptions, getDefaultMailClass}),

    ...logicModules({
        templateOptions, item,
        getDefaultQuantity,
    }),
    ...valueModules({}),
];

const logicModules = ({templateOptions, item, getDefaultQuantity,}) => [
    {
        name: "deliveryMethod1",
        load: ({}, next) => DeliveryMethodLogic({templateOptions, item, next}),
        expo: [itemEditor],
    },

    {
        name: "quantity1",
        load: ({}, next) => QuantityLogic({
            getDefaultQuantity,
            item,
            next,
        }),
        expo: [cleanItem],
    },
    {
        name: "quantity2",
        load: ({quantity1, method, enableAddressableShippingLogic2}, next) => (
            (
                ["shipping", "pickup"].includes(method) &&
                !enableAddressableShippingLogic2?.state.value
            ) ? (
                quantity1.next({
                    next,
                })
            ) : (
                next(null)
            )
        ),
        requires: ["quantity1", "method"],
        requiresOptional: ["enableAddressableShippingLogic2"],
        expo: [itemEditor],
    },

    {
        name: "downloadQuantity",
        load: ({method}, next) => next(method !== "download" ? (
            null
        ) : ({
            totalQuantity: 1,
            itemEditor: {
                valid: true,

                prepareSave: (item) => ({
                    newValue: changeNestedValue(item, ["selections", "quantity"], (_) => 1),
                }),
            }
        })),
        requires: ["method"],
        expo: [itemEditor],
    },


    {
        name: "pdfDownload1",
        load: ({method}, next) => PdfDownloadLogic({item, templateOptions, method, next}),
        requires: ["method"],

        expo: [cleanItem],
    },

    {
        name: "pdfDownload2",
        load: ({pdfDownload1, method}, next) => ["mailing", "shipping", "pickup"].includes(method) ? (
            pdfDownload1.next({next})
        ) : (
            next(null)
        ),
        requires: ["pdfDownload1", "method"],
        expo: [itemEditor],
    },

];


const valueModules = ({}) => [
    {
        name: "method",
        load: ({deliveryMethod1}, next) => next(deliveryMethod1.method),
        requires: ["deliveryMethod1"],
    },
    {
        name: "userQuantity",
        load: ({quantity2, downloadQuantity, addressableShippingQuantity2}, next) => next(
            quantity2 ?.totalQuantity ??
            addressableShippingQuantity2 ?.totalQuantity ??
            downloadQuantity ?.totalQuantity ??
            0
        ),
        requires: ["quantity2", "downloadQuantity"],
        requiresOptional: ["addressableShippingQuantity2"],
    },

    {
        name: "totalQuantity",
        load: ({addressLists2, userQuantity, sampleMailingCard, ncoaFailedCount2}, next) => next(
            ncoaFailedCount2 != null && ncoaFailedCount2.count == null ? (
                null
            ) : (
                (
                    (addressLists2?.quantity ?? 0) +
                    (sampleMailingCard?.includeSampleCardCost ? 1 : 0) +
                    (ncoaFailedCount2?.count ?? 0)
                ) + (
                    userQuantity
                )
            )
        ),
        requires: ["userQuantity"],
        requiresOptional: ["addressLists2", "ncoaFailedCount2", "sampleMailingCard"],
        expo: [],
    },
];
